import service from "./service";

export const findAll = listQuery => {
  return service.get("/v1/customer", listQuery);
};

export const findOne = id => {
  return service.get(`/v1/customer/${id}`);
};

export const findQuota = id => {
  return service.get(`/v1/quota/customer/${id}`);
};

export const update = (id, data) => {
  return service.post(`/v1/customer/${id}/update`, data);
};

export const updateUserManage = (id, userManage) => {
  return service.post(`/v1/customer/${id}/user-manage`, { userManage });
};

export const create = data => {
  return service.post(`/v1/customer`, data);
};

export const remove = id => {
  return service.post(`/v1/customer/${id}/delete`);
};

export const removeList = list => {
  return service.post(`/v1/customer/deletes`, list);
};

export const verify = id => {
  return service.post(`/v1/customer/${id}/verify`);
};

export const createContact = data => {
  return service.post(`/v1/contactCustomer`, data);
};
export const updateContact = (id, data) => {
  return service.post(`/v1/contactCustomer/${id}/update`, data);
};

export const removeContactList = list => {
  return service.post(`/v1/contactCustomer/deletes`, list);
};
